import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import {
  NewRelicCapacitorPlugin,
  NREnums,
  AgentConfiguration
} from '@newrelic/newrelic-capacitor-plugin';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root',
})

export class NewRelicService {
  private initialized = false;
  private isAuthorized = false;

  private getPlatformToken(): string {
    const platform = Capacitor.getPlatform();
    return platform === 'ios'
      ? 'AA5e23d856da277c98e0689a9db41c1db9e0c75ddd-NRMA'
      : platform === 'android'
        ? 'AAc4953a74111f4f7d5107b64a6e1d8fbd741d929e-NRMA'
        : '';
  }

  async init(): Promise<void> {
    // const platform = Capacitor.getPlatform();
    // if (platform === 'web') {
    //   console.log('New Relic not supported on web.');
    //   return;
    // }

    // if (this.initialized) return;

    // const appToken = this.getPlatformToken();


    // const config: AgentConfiguration = {
    //   // Android specific option
    //   // Optional: Enable or disable collection of event data.
    //   analyticsEventEnabled: true,

    //   // iOS specific option
    //   // Optional: Enable/Disable automatic instrumentation of WebViews.
    //   webViewInstrumentation: true,

    //   // Optional: Enable or disable crash reporting.
    //   crashReportingEnabled: true,

    //   // Optional: Enable or disable interaction tracing. Trace instrumentation still occurs, but no traces are harvested. This will disable default and custom interactions.
    //   interactionTracingEnabled: true,

    //   // Optional: Enable or disable reporting successful HTTP requests to the MobileRequest event type.
    //   networkRequestEnabled: true,

    //   // Optional: Enable or disable reporting network and HTTP request errors to the MobileRequestError event type.
    //   networkErrorRequestEnabled: true,

    //   // Optional: Enable or disable capture of HTTP response bodies for HTTP error traces, and MobileRequestError events.
    //   httpResponseBodyCaptureEnabled: true,

    //   // Optional: Enable or disable agent logging.
    //   loggingEnabled: true,

    //   // Optional: Specifies the log level. Omit this field for the default log level.
    //   // Options include: ERROR (least verbose), WARNING, INFO, VERBOSE, AUDIT (most verbose).
    //   logLevel: NREnums.LogLevel.INFO,

    //   // Optional: Enable or disable sending JS console logs to New Relic.
    //   sendConsoleEvents: true
    // };

    // await NewRelicCapacitorPlugin.start({
    //   appKey: appToken,
    //   agentConfiguration: config,
    // });
    // await this.removeAllAttributes();
    // this.initialized = true;
    // console.log('✅ New Relic initialized');
  }

  setIsAuthorized(isAuthorized: boolean): void {
    // this.isAuthorized = isAuthorized
  }


  async shutdown(): Promise<void> {
    // if (this.initialized) {
    //   await NewRelicCapacitorPlugin.removeAllAttributes();
    //   await NewRelicCapacitorPlugin.shutdown();
    //   this.initialized = false;
    //   console.log('New Relic shut down');
    // }
  }

  async shutdown2(): Promise<void> {
    // try {
    //   await NewRelicCapacitorPlugin.removeAllAttributes();
    //   await NewRelicCapacitorPlugin.shutdown();
    //   this.initialized = false;
    //   this.setIsAuthorized(false);
    //   console.log('New Relic shut down');
    // }
    // catch (e) {

    // }
  }

  recordBreadcrumb(name: string, attributes: object = {}): void {
    // if (this.initialized && this.isAuthorized == true) {
    //   NewRelicCapacitorPlugin.recordBreadcrumb({ name, eventAttributes: attributes });
    // }
  }

  recordError(message: string, stack: string = '', isFatal: boolean = false): void {
    // if (this.initialized && this.isAuthorized == true) {
    //   NewRelicCapacitorPlugin.recordError({
    //     message,
    //     stack,
    //     isFatal,
    //     name: ''
    //   });
    // }
  }



  trackHttpTransaction(url: string, method: string, status: number, startTime: number, endTime: number, requestBody: any, responseBody: any): void {
    // if (!this.initialized) return;
    // if (this.isAuthorized == false) {
    //   return
    // }
    // NewRelicCapacitorPlugin.noticeHttpTransaction({
    //   url, method, status, startTime, endTime, bytesSent: JSON.stringify(requestBody).length, bytesReceived: JSON.stringify(responseBody).length, body: JSON.stringify(responseBody),
    // });

    // this.recordBreadcrumb('API_Request_Success', {
    //   url,
    //   method,
    //   status,
    //   duration: endTime - startTime,
    //   responseBody: JSON.stringify(responseBody),
    //   requestBody: JSON.stringify(requestBody)
    // });
  }

  trackHttpFailure(
    url: string,
    method: string,
    startTime: number,
    endTime: number,
    error: any
  ): void {
    // if (!this.initialized || this.isAuthorized === false) return;

    // try {
    //   // Only log if error has a message (to prevent native crash on null)
    //   const failureMessage =
    //     error && typeof error.message === 'string'
    //       ? error.message
    //       : 'Unknown error';

    //   NewRelicCapacitorPlugin.noticeNetworkFailure({
    //     url,
    //     method,
    //     startTime,
    //     endTime,
    //     failure: failureMessage,
    //   });
    // } catch (err) {
    //   console.warn('[NewRelic] noticeNetworkFailure failed:', err);
    // }

    // this.recordError(`API call to ${url} failed`, error?.stack || '', false);
  }



  async startInteraction(name: string): Promise<string | null> {
    // if (!this.initialized) return null;
    // if (this.isAuthorized == false) {
    //   return null;
    // }
    // const result = await NewRelicCapacitorPlugin.startInteraction({ value: name });
    // return result.value;
    return "";
  }

  endInteraction(interactionId: string): void {
    // if (this.initialized && interactionId) {
    //   NewRelicCapacitorPlugin.endInteraction({ interactionId });
    // }
  }

  removeAllAttributes() {
    // NewRelicCapacitorPlugin.removeAllAttributes();
  }

  setUserId(MemberId?: number) {
    // NewRelicCapacitorPlugin.setUserId({ userId: MemberId.toString() });
  }

  setUserInfo(UserId: number, MemberId?: number, LastName?: string, FirstName?: string, UserTypeId?: number, BusinessId?: number, businessName?: string, businessAlias?: string, ConsentNotificationReceived?: boolean): void {
    // if (!this.initialized) return;

    // const safe = (val: any): string => (val === null || val === undefined ? '' : String(val));

    // NewRelicCapacitorPlugin.setAttribute({ name: 'UserId', value: safe(UserId) });
    // NewRelicCapacitorPlugin.setAttribute({ name: 'DeviceOs', value: Capacitor.getPlatform() });
    // NewRelicCapacitorPlugin.setAttribute({ name: 'Version', value: safe(environment.build_VersionNumber) });

    // NewRelicCapacitorPlugin.setAttribute({ name: 'MemberId', value: safe(MemberId) });
    // NewRelicCapacitorPlugin.setAttribute({ name: 'LastName', value: safe(LastName) });
    // NewRelicCapacitorPlugin.setAttribute({ name: 'FirstName', value: safe(FirstName) });
    // NewRelicCapacitorPlugin.setAttribute({ name: 'UserTypeId', value: safe(UserTypeId) });
    // NewRelicCapacitorPlugin.setAttribute({ name: 'BusinessId', value: safe(BusinessId) });
    // NewRelicCapacitorPlugin.setAttribute({ name: 'businessName', value: safe(businessName) });
    // NewRelicCapacitorPlugin.setAttribute({ name: 'businessAlias', value: safe(businessAlias) });
    // NewRelicCapacitorPlugin.setAttribute({
    //   name: 'ConsentNotificationReceived',
    //   value: safe(ConsentNotificationReceived)
    // });
  }
}
